angular
	.module('app.core')
	.controller('procurementTaskCtrl', procurementTaskCtrl)
	.directive('watcherSelect', watcherSelect);

procurementTaskCtrl.$inject = ['$rootScope', '$scope', '$location', '$anchorScroll', '$uibModal', 
	'$timeout', '$filter', '$compile', '$q', '$translate', 'procurementTaskService', 'currencyFormatService', 
	'watcherFunctionsService', 'inventoryActionConfigService', 'inventoryActionsService', 'notificationService'];

function procurementTaskCtrl($rootScope, $scope, $location, $anchorScroll, $uibModal, 
		$timeout, $filter, $compile, $q, $translate, procurementTaskService, currencyFormatService,
		watcherFunctionsService, inventoryActionConfigService, inventoryActionsService, notificationService) {
	$scope.tasks = [];
	$scope.showAddComment = false;
	$scope.newCommentText = '';
	$scope.editComment = '';
	$scope.editing = false;
	$scope.disableAddComment = false;
	$scope.incomingLocation = 'item drilldown';
	$scope.showAddTask = true;
	var icons = {
		'Open': '&#xf044;',
		'Fixed': '&#xf046;',
		'Review Later': '&#xf017',
		'Unable to Fix': '&#xf147;'
	};
	var iconTooltip = {
		'None': 'No task, click to add task',
		'Open': 'Task status is Open, click to edit task',
		'Fixed': 'Task status is Fixed, click to edit task',
		'Review Later': 'Task status is Review Later, click to edit task',
		'Unable to Fix': 'Task status is Unable to Fix, click to edit task'
	};
	var iconMap = {
		'None': 'fa fa-plus task-status-none',
		'Open': 'fa fa-circle task-status-open',
		'Fixed': 'fa fa-circle task-status-fixed',
		'Review Later': 'fa fa-circle-o task-status-review-later',
		'Unable to Fix': 'fa fa-circle task-status-unable-to-fix',
		'Expired': 'fa fa-circle task-status-expired'
	};
	var urlMap = {
		'category': procurementTaskService.getCategories,
		'responsible': procurementTaskService.getUsers,
		'status': procurementTaskService.getStatuses,
		'IAStatus': procurementTaskService.getIAStatuses
	};
	var variableLabel = {
		'category': 'Category',
		'subject': 'Subject',
		'status': 'Status',
		'responsible': 'Responsible',
		'dueDate': 'Due Date',
		'description': 'Description',
		'comments': 'Comment'
	};
	$scope.actionCategories;
	$scope.actionStatuses = [];
	$scope.display = {};
	$scope.display.loading = true;
	$scope.lists = {};
	$scope.inlineEditing = {};
	$scope.specificTaskId = '';
	$scope.currentUserNdx = globalConfig.user.id;
	$scope.unableToFixCategoriesLoaded = false;
	var oldUnableToFixCategoryNdx = undefined;
	$scope.reviewLaterDatePickerOptions = {
		minDate: new Date(Date.now() + (24 * 60 * 60 * 1000)),
		initDate: new Date(Date.now() + 12096e5), // 2 weeks from now
		showWeeks: false
	};

	$scope.selected = {};

	$scope.showTaskCount = 3;

	var factoryNdx;
	var userListPromise;

	// TAGGING
	$scope.watchersObject = {
		suffixForTagging: '',
		prefixForTagging: '',
		emailSuffix: undefined,
		tempWatchers: {},
		displayNoUsersFound: false
	};
	$scope.getUsersForTagging = watcherFunctionsService.getUsersForTagging;
	$scope.formatTagResult = watcherFunctionsService.formatTagResult;

	$scope.taskAvailableStatuses = function(task) {
		if (task.inventoryActionId) {
			return $scope.actionStatuses.filter(function(status) {
				return status.name !== task.status.name
					&& ['Unable to Fix', 'Open'].indexOf(status.name) !== -1;
			});
		} else {
			return $scope.actionStatuses.filter(function(status) {
				return task.status.name !== status.name;
			});
		}
	};

	// Manage task view state
	$scope.openTask = function(task) {
		if (task.viewMode === 'mini') {
			task.viewMode = 'open';
		}
	};

	$scope.showTaskDetails = function(task) {
		task.viewMode = 'details';
	};

	$scope.showMoreComments = function(task) {
		task.showCommentCount += 5;
	};

	$scope.hasMoreComments = function(task) {
		if (task.viewMode === 'details') {
			return task.showCommentCount < task.comments.length;
		}
		return task.showCommentCount <= task.comments.length;
	};

	// New inline editing
	$scope.taskCanEditSubject = function(task) {
		return task.viewMode === 'details'
			&& task.active
			&& !task.inventoryActionId;
	};
	$scope.updateTaskSubject = function(task) {
		if (task.subjectText.trim() === '') {
			// do not save empty subject
			return;
		}
		$timeout(200).then(function(){
			if (task.subject !== task.subjectText) {
				task.subject = task.subjectText;
				editExistingAction(task).then(function() {
					broadCastProcurementTaskUpdates('subject', task);
				});
			}
		});
	};

	$scope.updateTaskResponsible = function(task) {
		task.ownerNdx = task.responsible.ndx;
		editExistingAction(task).then(function() {
			broadCastProcurementTaskUpdates('responsible', task);
			postEditAction(task);
		});
	};

	$scope.updateTaskResponsibleAndAddComment = function(task, unableToFixCategory) {
		var status = getStatus('Open'); // Sets back to open
		document.removeEventListener('click', outsidePopoverClickListener);
		task.status = status;
		task.statusName = status.name;
		task.statusNdx = status.ndx;
		task.needsReason = false;
		task.responsible = task.responsibleTemp;
		task.ownerNdx = task.responsibleTemp.ndx;
		task.responsibleTemp = undefined;
		editExistingAction(task).then(function() {
			postEditAction(task);
		});
		$scope.selected.unableToFixCategory = undefined;
		var commentText = globalConfig.user.firstName + ' ' + globalConfig.user.lastName + ' has categorized this '
			+ 'a "' + unableToFixCategory.categoryName + '" issue and assigned the task to ' 
			+ task.responsible.firstName + ' ' + task.responsible.lastName + '.';
		addCommentToAction({
			'comment': commentText, // this to bypass OvalChecks
			'taskId': task.id,
			'isUnableToFixCommentFlag': false,
			'systemGenerated': true,
			'assignToPlannerNdx': task.responsible.ndx,
			'unableToFixCategoryNdx': unableToFixCategory.ndx
		});
		task.needsReasonAfterUpdate = false;
	};

	$scope.canEditComment = function(task, index) {
		return task.active && task.comments[index].userNdx === globalConfig.user.id;
	};

	function resetCommentAreas() {
		$('.task-comments textarea').css('height', '');
	}
	$scope.startEditingComment = function(task, index) {
		if (!$scope.canEditComment(task, index)) {
			return;
		}
		task.commentEditingIndex = index;
		task.commentEditingText = task.comments[index].comment;
	};
	$scope.cancelEditingComment = function(task) {
		task.commentEditingText = task.comments[task.commentEditingIndex].comment;
		$timeout(200).then(function() {
			task.commentEditingIndex = undefined;
			resetCommentAreas();
		});
	};
	$scope.updateComment = function(task) {
		if (task.commentEditingText.trim() === '') {
			// do not save empty subject
			return;
		}
		var promises = addWatchersIfAny(task.id, task.commentEditingText);
		$q.all(promises).then(function(){
			editExistingComment(task.id, task.commentEditingIndex, task.commentEditingText)
				.then(function() {
					task.commentEditingIndex = undefined;
					task.commentEditingText = undefined;
					resetCommentAreas();
				});
		});
		clearTaggingVariables(task.id);
	};

	$scope.taskCanEditCategory = function(task) {
		return task.active && !task.inventoryActionId;
	};

	$scope.canEditActualSavings = function() {
		return globalConfig.user.invalidateInventoryActions ||
				$rootScope.authz.isLeanDNAAdmin();
	};

	// Filter to show only active categories (exclude 'inactive' or 'archived')
	// Categories without a state property are treated as active (for backwards compatibility)
	$scope.getActiveUnableToFixCategories = function() {
		if (!$scope.lists.unableToFixCategories) {
			return [];
		}
		return $scope.lists.unableToFixCategories.filter(function(category) {
			return !category.state || category.state === 'active';
		});
	};

	$scope.showUnableToFixInDetails = function(task) {
		return $scope.unableToFixCategoriesLoaded && $scope.lists.unableToFixCategories && task.inventoryActionId
			&& $scope.getActiveUnableToFixCategories().length > 0 && task.statusName === 'Unable to Fix';
	};

	$scope.resolveUnableToFixCategoryNdx = function(task) {
		$scope.selected.unableToFixCategory = _.find($scope.lists.unableToFixCategories, {ndx: task.unableToFixCategoryNdx});
		task.needsReasonAfterUpdate = true;
	};

	$scope.saveCurrentUnableToFixCategory = function(task) {
		oldUnableToFixCategoryNdx = task.unableToFixCategoryNdx;
	};

	$scope.reviewLaterDateAfterDueDate = function(task) {
		return moment(task.reviewLaterDate).isAfter(task.dueDate, 'day');
	};

	$scope.updateUnableToFixCategory = function(task) {
		if (task.inventoryActionId) {
			var event = {
				'id': task.inventoryActionId
			};
			var canSave = canSaveStatusUnableToFix(task);
			if (!canSave){
				return task.needsReasonAfterUpdate = true;
			}
			var reasonComment = generateUnableToFixComment(task);
			var promiseList = addWatchersIfAny(task.id, reasonComment);
			$q.all(promiseList).then(function() {
				// clear out the isUnableToFixCommentFlag for existing comments for this task
				if (task.comments && task.comments.length) {
					task.comments.forEach(function(com) {
						com.isUnableToFixCommentFlag = false;
					});
				}
				addCommentToAction({
					'comment': reasonComment,
					'taskId': task.id,
					'isUnableToFixCommentFlag': true
				});
				if ($scope.selected.unableToFixCategory && $scope.selected.unableToFixCategory.categoryName) {
					procurementTaskService.updateInventoryActionUnableToFixCategory(factoryNdx, task.inventoryActionId, $scope.selected.unableToFixCategory.ndx)
						.then(function(response) {
							var updateRowsObject = {};
							updateRowsObject.identifier = {
								taskId: task.id
							};
							updateRowsObject.newValues = {unableToFixCategoryName: $scope.selected.unableToFixCategory.categoryName};
							$rootScope.$broadcast('updateRows', updateRowsObject);
							$scope.selected.unableToFixCategory = undefined;
						});
				}
			});
			clearTaggingVariables(task.id);
			event.unableToFixComment = reasonComment;
			event.isUnableToFix = true;
		
			$rootScope.$broadcast('updateUnableToFix', event);
			task.reason = undefined;
			task.needsReasonAfterUpdate = false;
		}
	};

	$scope.cancelUnableToFixCategoryChange = function(task) {
		task.needsReasonAfterUpdate = false;
		task.unableToFixCategoryNdx = oldUnableToFixCategoryNdx;
		$scope.selected.unableToFixCategory = undefined;
	};

	$scope.updateTaskCategory = function(task) {
		task.categoryNdx = task.category.id;
		if (hasNewCategory($scope.lists.category, task.category)) {
			addCategoryInline(task.category || [])
				.then(function () {
					if (!task.category.id || task.category.id === -1) {
						// Task category creation was not successful
						$rootScope.$emit('toast', {
							'message': 'Task Category was not created, please try again',
							'success': false
						});
						return;
					}
					editExistingAction(task).then(function() {
						broadCastProcurementTaskUpdates('category', task);
						postEditAction(task);
					});
				});
		} else {
			editExistingAction(task).then(function() {
				broadCastProcurementTaskUpdates('category', task);
				postEditAction(task);
			});
		}
	};

	$scope.taskCanEditDescription = function(task) {
		return task.active && task.userGenerated;
	};
	$scope.startEditingDescription = function(task) {
		if (!$scope.taskCanEditDescription(task)) {
			return;
		}
		task.editingDescription = true;
		task.descriptionText = task.description;
	};
	$scope.cancelDescriptionEdit = function(task) {
		task.descriptionText = task.description;
		$timeout(200).then(function() { task.editingDescription = undefined; });
	};
	$scope.updateTaskDescription = function(task) {
		if (task.descriptionText.trim() === '') {
			// do not save empty subject
			return;
		}
		task.description = task.descriptionText;
		var promiseList = addWatchersIfAny(task.id, task.descriptionText);
		$q.all(promiseList).then(function() {
			editExistingAction(task).then(function() {
				task.editingDescription = false;
				task.descriptionEditUtcTime = new Date().getTime();
				task.descriptionEditorLastName = globalConfig.user.lastName;
				task.descriptionEditorFirstName = globalConfig.user.firstName;
				postEditAction(task);
			});
		});
		clearTaggingVariables(task.id);
	};

	$scope.openTaskDueDatePicker = function(task) {
		task.dueDatePickerOpen = true;
	};
	$scope.updateTaskDueDate = function(task, event) {
		if (task.dueDateInline && task.dueDateInline.getTime() !== task.dueDate) {
			task.dueDate = task.dueDateInline.getTime();
			editExistingAction(task).then(function() {
				broadCastProcurementTaskUpdates('dueDate', task);
				postEditAction(task);
			});
		} else {
			task.dueDateInline = new Date(task.dueDate);
		}
	};

	$scope.openTaskReviewLaterExpireDatePicker = function(task) {
		task.reviewLaterExpireDatePickerOpen = true;
	};

	$scope.updateTaskReviewLaterExpireDate = function(task, event) {
		if (task.reviewLaterExpireDateInline && task.reviewLaterExpireDateInline.getTime() !== task.reviewLaterExpireDate) {
			task.reviewLaterExpireDate = task.reviewLaterExpireDateInline.getTime();
			editExistingAction(task).then(function() {
				postEditAction(task);
			});
		} else {
			task.reviewLaterExpireDateInline = new Date(task.reviewLaterExpireDate);
		}
	};

	$scope.taskCanUpdateStatus = function(task) {
		if (!task.active) {
			return false;
		}
		if (task.inventoryActionId) {
			if (['Unable to Fix', 'Open'].indexOf(task.status.name) === -1) {
				return false;
			} else if (task.canUpdateStatus === false) {
				return false;
			}
		}
		return true;
	};

	var outsidePopoverClickListener = null;

	$scope.cancelStatusChange = function(task) {
		document.removeEventListener('click', outsidePopoverClickListener);
		if (task.originalStatus) {
			task.status = task.originalStatus;
			task.originalStatus = undefined;
		}
		$scope.selected.unableToFixCategory = undefined;
		task.needsReason = false;
		task.needsReviewLaterDate = false;
		task.reviewLaterDate = undefined;
		task.originalStatus = undefined;
	};
	
	function cancelStatusChangeOnOutsidePopoverClick(e, task) {
		var popover = document.querySelector('.task-status-unable-to-fix-comment-container');
		var isUnableToFixOption = e.target.classList.contains('task-status-unable-to-fix-option')
			|| (
				!!e.target.childNodes && !!e.target.childNodes[1]  && !!e.target.childNodes[1].classList 
				&& e.target.childNodes[1].classList.contains('task-status-unable-to-fix-option')
			);
		var targetIsPopoverOrDescendant = popover === e.target || popover.contains(e.target);
		var targetIsUnableToFixButton = e.target.classList.contains('task-status-dropdown-option') && e.target.innerText === 'Unable to Fix';
		if (!isUnableToFixOption && !targetIsPopoverOrDescendant && !targetIsUnableToFixButton) {
			$timeout(function () { $scope.cancelStatusChange(task); });
		}
	}

	$scope.cancelSavingsValidityChange = function(task) {
		task.showInvalidateSavings = 0;
		task.hasValidSavings = task.originalSavingsValidity;
		task.invalidSavingsComment = task.originalInvalidSavingsComment;
	};

	$scope.focusReason = function (taskId) {
		var name = taskId + 'reason';
		$timeout(function() {
			jQuery('textarea[name="' + name + '"]').focus();
		});
	};

	$scope.clickedStatusChange = function (task) {
		task.needsReviewLaterDate = false;
		task.reviewLaterDate = undefined;
		if (task.originalStatus) {
			task.status = task.originalStatus;
			task.originalStatus = undefined;
		}
	};

	$scope.updateTaskStatus = function(task, status) {
		task.originalStatus = task.status;
		if ( typeof status === 'string' ) {
			status = getStatus(status);
		}
		task.status = status;
		if (status.name === 'Review Later' && task.originalStatus.name !== 'Review Later') {
			task.needsReviewLaterDate = !task.reviewLaterDate;
			if (task.needsReviewLaterDate){
				task.reviewLaterDate = $scope.reviewLaterDatePickerOptions.initDate;
				return true;
			}
		}

		if (task.inventoryActionId) {
			var event = {
				'id': task.inventoryActionId
			};
			if (status.name === 'Unable to Fix') {
				var canSave = canSaveStatusUnableToFix(task);
				if (!canSave){
					task.needsReason = true;
					outsidePopoverClickListener = function (e) {
						cancelStatusChangeOnOutsidePopoverClick(e, task);
					};
					document.addEventListener('click', outsidePopoverClickListener);
					return;
				}
				var reasonComment = generateUnableToFixComment(task);
				var promiseList = addWatchersIfAny(task.id, reasonComment);
				$q.all(promiseList).then(function() {
					addCommentToAction({
						'comment': reasonComment,
						'taskId': task.id,
						'isUnableToFixCommentFlag': true
					});
					if ($scope.selected.unableToFixCategory && $scope.selected.unableToFixCategory.categoryName) {
						procurementTaskService.updateInventoryActionUnableToFixCategory(factoryNdx, task.inventoryActionId, $scope.selected.unableToFixCategory.ndx)
							.then(function(response) {
								var updateRowsObject = {};
								updateRowsObject.identifier = {
									taskId: task.id
								};
								updateRowsObject.newValues = {unableToFixCategoryName: $scope.selected.unableToFixCategory.categoryName};
								$rootScope.$broadcast('updateRows', updateRowsObject);
								$scope.selected.unableToFixCategory = undefined;
							});
					}
				});
				clearTaggingVariables(task.id);
				event.unableToFixComment = reasonComment;
				event.isUnableToFix = true;
			}	else {
				event.unableToFixComment = undefined;
				event.isUnableToFix = false;
			} 
			document.removeEventListener('click', outsidePopoverClickListener);
			$rootScope.$broadcast('updateUnableToFix', event);
			task.reason = undefined;
			task.needsReason = false;
		}

		if (status.name === 'Review Later') {
			task.reviewLaterExpireDate = task.reviewLaterDate;
			task.needsReviewLaterDate = false;
		} else {
			task.reviewLaterExpireDate = undefined;
		}
		task.reviewLaterDate = undefined;

		task.status = status;
		task.statusName = status.name;
		task.statusNdx = status.ndx;
		task.originalStatus = undefined;

		editExistingAction(task).then(function() {
			broadCastProcurementTaskUpdates('status', task);
			postEditAction(task);
		});
	};

	$scope.updateTaskSavingsValidity = function(task) {
		if (!task.showInvalidateSavings) {
			// show the edit popup
			task.showInvalidateSavings = 1;
			task.originalSavingsValidity = task.hasValidSavings;
			task.originalInvalidSavingsComment = task.invalidSavingsComment;
		} else {
			// save the values
			task.showInvalidateSavings = 0;
			inventoryActionsService.saveInventoryActionValidSavings(task.factoryNdx,
				task.inventoryActionId, task.hasValidSavings, task.invalidSavingsComment)
			.then(function() {
				var updateRowsObject = {};
				updateRowsObject.identifier = {
					actionId: task.inventoryActionId
				};

				if (task.hasValidSavings !== task.originalSavingsValidity) {
					$rootScope.$broadcast('updateHeaders', {
						hasValidSavings: task.hasValidSavings,
						actualSavings: task.originalSavings.actualSavings
					});
				}

				updateRowsObject.newValues = {};
				updateRowsObject.newValues.hasValidSavings = task.hasValidSavings;
				updateRowsObject.newValues.invalidSavingsComment = task.invalidSavingsComment;
				$rootScope.$broadcast('updateRows', updateRowsObject);
			});
		}
	};

	function broadCastProcurementTaskUpdates(action, task) {
		$rootScope.$broadcast('procurementTaskUpdated', {
			'action': action,
			'task': task
		});
	}

	function generateUnableToFixComment(task) {
		var comment = 'Unable to Fix';
		if ($scope.selected.unableToFixCategory 
			&& $scope.selected.unableToFixCategory.categoryName 
			&& $scope.selected.unableToFixCategory.categoryName !== 'Other...') {
			comment += ': ' + $scope.selected.unableToFixCategory.categoryName;
		}
		if (task.reason && task.reason.length) {
			comment += ': ' + task.reason;
		}
		return comment;
	}

	function canSaveStatusUnableToFix(task) {
		if (!$scope.unableToFixCategoriesLoaded) {
			return false;
		}
		var activeCategories = $scope.getActiveUnableToFixCategories();
		if (!activeCategories || activeCategories.length === 0) {
			return !!task.reason;
		}
		if (!$scope.selected.unableToFixCategory || !$scope.selected.unableToFixCategory.categoryName) {
			return false;
		}
		if ($scope.selected.unableToFixCategory.categoryName === 'Other...') {
			return !!task.reason;
		}
		return true;
	}

	$scope.autoExpand = function(e) {
		var element = typeof e === 'object' ? e.target : document.getElementById(e);
		element.style.height =  (element.scrollHeight + 2) + 'px';
	};

	$scope.getAction = function (element, location, itemCode, row, rowIndex, incomingFactoryNdx, ignoreIncomingData, insidePanel, specificTaskType, taskId) {
		$scope.incomingLocation = location;
		$scope.element = element;
		$scope.row = row;
		$scope.rowIndex = rowIndex;
		$scope.display.isSupplier = globalConfig.user.role === 'Supplier';
		factoryNdx = incomingFactoryNdx && incomingFactoryNdx !== 'undefined' ? incomingFactoryNdx : globalConfig.factory.id;
		$scope.insidePanel = insidePanel;
		$scope.specificTaskType = specificTaskType;
		$scope.specificTaskId = taskId;

		procurementTaskService.getStatuses(factoryNdx)
			.then(function (data) {
				$scope.actionStatuses = data || [];
			});

		userListPromise = procurementTaskService.getUsers(factoryNdx);
		userListPromise.then(function (data) {
			if (!Array.isArray(data)) {
				return [];
			}
			$scope.lists['responsible'] = data.filter(function(user) {
				return user.roleType != 'Supplier';
			});
		});

		procurementTaskService.getCategories(factoryNdx, incomingData.itemNdx).then(function (data) {
			$scope.lists['category'] = data;
		});

		inventoryActionConfigService.getUnableToFixCategories(factoryNdx, true).then(function(data) {
			$scope.lists['unableToFixCategories'] = data;
			$scope.unableToFixCategoriesLoaded = true;
		});


		// TODO: incomingData is a global variable and should be get/set from a service instead
		//
		if (incomingData.itemNdx >= 0 || itemCode) {
			var func;
			if (incomingData.itemNdx >= 0 && !ignoreIncomingData) {
				func = procurementTaskService.getAction(incomingData.itemNdx, factoryNdx, true);
			} else {
				func = procurementTaskService.getActionByCode(itemCode, factoryNdx, true);
			}
			$scope.display.loading = true;
			return func
				.then(function (data) {
					$scope.tasks = data ? data : [];
					getEmailSuffix();

					var openActionTypes = [];
					_.forEach($scope.tasks, function (task, key) {
						taskPrep(task);
						// find all open IA types
						if (task.statusName === 'Open' && task.inventoryActionType) {
							openActionTypes.push(task.inventoryActionType);
						}
					});
					_.forEach($scope.tasks, function (task, key) {
						// mark actions as uneditable if there is an open action of same type
						if (task.statusName === 'Unable to Fix' &&
								openActionTypes.indexOf(task.inventoryActionType) !== -1) {
							task.canUpdateStatus = false;
						}
					});

					$scope.tasks.sort(function (a, b) {
						return b.lastModifiedDate - a.lastModifiedDate;
					});

					$scope.itemCode = incomingData.itemCode;
					$scope.itemCodeDisplay = incomingData.itemCodeDisplay;
					if ($scope.specificTaskId) {
						if ($scope.specificTaskType === 'action') {
							$scope.specificTask = _.find($scope.tasks, {
								inventoryActionId: taskId
							});
						} else if ($scope.specificTaskType === 'task') {
							$scope.specificTask = _.find($scope.tasks, {
								id: taskId
							});
						}
						if ($scope.specificTask) {
							$scope.specificTask.viewMode = 'open';
							$scope.specificTask.showCommentCount = 1;
						}
					} else {
						$scope.specificTaskId = '';
					}
					broadCastShowAddTask();
					$scope.display.loading = false;
				});
		} else {
			$scope.showAddTask = true;
		}
	};

	function taskPrep(task) {
		task.viewMode = task.viewMode || 'mini';
		task.showCommentCount = task.showCommentCount || 1;

		watcherSelectInit(task);


		if (task.savings && typeof task.savings !== 'string') {
			task.originalSavings = task.savings;
			switch (task.statusName) {
			case 'Open':
			case 'Unable to Fix':
				task.savings = task.savings.potentialSavings;
				task.savingsLabel = 'Potential Savings';
				break;
			case 'Fixed':
				task.savings = task.savings.actualSavings;
				task.savingsLabel = 'Realized Value';
				break;
			case 'Expired':
				task.savings = task.savings.expiredSavings;
				task.savingsLabel = 'Expired Savings';
				break;
			}
			var currencySymbol = globalConfig.user.authFacts[task.factoryNdx].currencySymbol;
			task.savings = currencyFormatService.getWithParameters(task.savings, 0, currencySymbol);

			task.actualSavingsOptions = [
				{
					isValid: true,
					display: task.savings
				}, {
					isValid: false,
					display: $translate.instant('Invalidate Realized Value')
				}
			];
		}

		// Set if user or system generated
		if (task.isSystemGenerated) {
			task.userGenerated = false;
		} else {
			task.userGenerated = true;
			$scope.showAddTask = false;
		}

		if (task.ownerNdx) {
			task.responsible = {
				'ndx': task.ownerNdx,
				'firstName': task.ownerFirstName,
				'lastName': task.ownerLastName,
				'state': task.responsibleState
			};
		}

		if (task.categoryNdx) {
			var category = _.find($scope.lists.category, ['id', task.categoryNdx]);
			if (category) {
				task.category = category;
			} else {
				task.category = {
					'id': task.categoryNdx,
					'name': task.categoryName,
					'displayName': task.categoryDisplayName,
					'isActive': task.activeCategory
				};
			}

		}

		if (task.subject) {
			task.subject = _.unescape(task.subject);
		}

		var utcDate, localDate;

		if (task.creationDate) {
			utcDate = new Date(task.creationUtcTime);
			localDate = moment(utcDate).subtract(utcDate.getTimezoneOffset(), 'minutes');
			task.creationTimeFromNow = moment(localDate._i).fromNow();
			task.creationDate = $filter('date')(localDate._i, 'medium');
		}

		if (task.descriptionEditUtcTime) {
			utcDate = new Date(task.descriptionEditUtcTime);
			localDate = moment(utcDate).subtract(utcDate.getTimezoneOffset(), 'minutes');
			task.editTimeFromNow = moment(localDate._i).fromNow();
			if (task.editTimeFromNow === task.creationTimeFromNow &&
					task.descriptionEditorFirstName === task.creatorFirstName &&
					task.descriptionEditorLastName === task.creatorLastName) {
				task.editTimeFromNow = undefined;
			}
		}

		if (task.dueDate) {
			var d = Date.parse(task.dueDate);
			task.dueDate = d;
			task.dueDateDisplay = $filter('date')(d, 'mediumDate');
			var momentDt =  moment().utc();
			task.pastDue = task.statusName === 'Open' && momentDt.isAfter(task.dueDate, 'day');

		}

		if (task.comments) {
			// Sort by most recent
			task.comments = _.reverse(_.sortBy(task.comments, ['creationUtcTime']));

			_.forEach(task.comments, function (comment, key) {
				var utcDate = new Date(comment.creationUtcTime);
				var localDate = moment(utcDate).subtract(utcDate.getTimezoneOffset(), 'minutes');
				comment.creationTimeFromNow = moment(localDate._i).fromNow();
				comment.creationTime = $filter('date')(localDate._i, 'medium');
				comment.comment = strip(comment.comment);
			});
		}

		if (task.statusNdx) {
			var iconClass = $scope.getStatusIcon(task.statusName);
			task.status = {
				'id': task.statusNdx,
				'name': task.statusName,
				'iconClass': iconClass
			};
		}
	}

	function broadCastShowAddTask() {
		$scope.$emit('showAddTask', $scope.showAddTask);
	}

	function getTextTemplate(taskId, position, variableName, variableDisplay, characterLimit) {
		var windowWidth = window.innerWidth;
		var windowHeight = window.innerHeight;
		if (position.left + 296 > windowWidth) {
			position.left = position.left - (position.left + 296 - windowWidth - 8);
		}
		if (position.top + 112 > windowHeight) {
			position.top = position.top - (position.top + 112 - windowHeight - 8);
		}
		var editTemplate = '<div class="inlineEditDiv absolute textEdit" style="top:' + position.top + 'px; left: ' +
			position.left + 'px;"><div class="inlineEditHeader">Change ' + variableDisplay + '</div>' +
			'<div class="input-holder-with-clear">' +
			'<input class="inlineEditInput with-clear" ng-model="inlineEditing.' + variableName + '" />' +
			'<span class="input-clear" ng-show="inlineEditing.' + variableName + ' && inlineEditing.' + variableName +
			'.length" ng-click="inlineEditing.' + variableName + ' = \'\'"><i class="fa fa-times"></i></span>' +
			(typeof characterLimit !== 'undefined' ?
				'<span class="error-desc" ng-if="inlineEditing.' + variableName + '.length>' + characterLimit +
				'">Max allowed characters are ' + characterLimit + '.</span>' :
				'') +
			'</div>' +
			'<div class="inlineEditButtons"><button class="button flat" ng-click="cancelInlineEdit(' + taskId + ",'" + variableName + "'" + ')">Cancel</a>' +
			'<button class="button flat colored" ng-disabled="' + (typeof characterLimit !== 'undefined' ? 'inlineEditing.' + variableName + '.length>' + characterLimit + ' || ' : '') +
			'(!inlineEditing.' + variableName + ' || !inlineEditing.' + variableName + '.length) && !(inlineEditing.' + variableName + ' === false)" ng-click="saveInlineEdit(' + taskId + ",'" + variableName + "'" + ')">Save</a></div></div>';
		return editTemplate;
	}

	function getTextAreaTemplate(taskId, position, variableName, variableDisplay, index, myTasksView, outerContinerWidth) {
		var windowWidth = window.innerWidth;
		var windowHeight = window.innerHeight;
		var containerWidth = $scope.insidePanel ? 605 : 840;
		if (position.left + containerWidth > windowWidth) {
			position.left = position.left - (position.left + containerWidth - windowWidth - 8);
		}
		if (position.top + 140 > windowHeight) {
			position.top = position.top - (position.top + 140 - windowHeight - 8);
		}
		var textAreaWidth = typeof outerContinerWidth !== 'undefined' ? 'width:' + outerContinerWidth + 'px;' : '';
		var className = 'textAreaEdit';
		var disabledText = variableName == 'comments' ? ' ng-disabled="(!inlineEditing.' + variableName + ' || !inlineEditing.' + variableName + '.length) && !(inlineEditing.' + variableName + ' === false)" ' : '';
		var label = (variableName == 'comments' && index < 0) ? 'Add' : 'Change';
		if (myTasksView) className += ' myTasksView';
		var editTemplate = '<div class="inlineEditDiv absolute ' + className + '" style="top:' + position.top + 'px;' + textAreaWidth + '"><div class="inlineEditHeader">' + label + ' ' + variableDisplay + '</div>' +
			'<textarea style="max-height: 60px; height: 100%" class="inlineEditInput" ng-model="inlineEditing.' + variableName + '" >{{inlineEditing.' + variableName + '}}</textarea>' +
			'<div class="inlineEditButtons"><button class="button flat" ng-click="cancelInlineEdit(' + taskId + ",'" + variableName + "'" + ')">Cancel</a>' +
			'<button class="button flat colored"' + disabledText +
			' ng-click="saveInlineEdit(' + taskId + ",'" + variableName + "'" + ', ' + index + ')">Save</a></div></div>';
		return editTemplate;
	}

	function getDateTemplate(taskId, position, variableName, variableDisplay, myTasksView) {
		var windowWidth = window.innerWidth;
		var windowHeight = window.innerHeight;
		if ($scope.insidePanel) {
			windowWidth = jQuery('.details-container').width();
			windowHeight = jQuery('.details-container').height() - 49;
		}
		if (myTasksView) {
			windowWidth = jQuery('.task-' + variableName).width();
		}
		if (position.left + 340 > windowWidth) {
			position.left = position.left - (position.left + 340 - windowWidth - 8);
		}
		if (position.top + 356 > windowHeight) {
			position.top = position.top - (position.top + 356 - windowHeight - 8);
		}
		var editTemplate = '<div class="inlineEditDiv absolute dateEdit" style="top:' + position.top + 'px; left: ' +
			position.left + 'px;"><div class="inlineEditHeader">Choose a ' + variableDisplay + '</div>' +
			'<div uib-datepicker ng-model="inlineEditing.' + variableName + '" class="well well-sm"></div>' +
			'<div class="inlineEditButtons">' +
			'<a class="button flat" ng-click="cancelInlineEdit(' + taskId + ",'" + variableName + "'" + ')">Cancel</a>' +
			'<a class="button flat colored" ng-click="saveInlineEdit(' + taskId + ",'" + variableName + "'" + ')">Save</a></div></div>';
		return editTemplate;
	}

	function getListTemplate(taskId, position, variableName, variableDisplay, display, extraDisplay) {
		var windowWidth = window.innerWidth;
		var windowHeight = window.innerHeight;
		var width = 296;
		var extraClass = '';

		if (position.left + width > windowWidth) {
			position.left = position.left - (position.left + width - windowWidth - 8);
		}
		if (position.top + 112 > windowHeight) {
			position.top = position.top - (position.top + 112 - windowHeight - 8);
		}
		var checkForInactive = false;
		if (variableName == 'responsible') {
			checkForInactive = true;
		}

		var filter = 'filter: $select.search';

		var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv absolute textEdit ' + extraClass + '" ng-class="{ \'unable-to-fix\': inlineEditing.status.name === \'Unable to Fix\'}" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
			'<div class="inlineEditHeader">Change ' + variableDisplay + '</div>' +
			'<ui-select theme="bootstrap" ng-model="inlineEditing.' + variableName + '">' +
			'<ui-select-match placeholder="{{' + "'Select " + variableDisplay + "...'" + ' | translate}}">' +
			'<div ng-bind-html="$select.selected.' + display + (extraDisplay && extraDisplay.length ? ' + "," + $select.selected.' + extraDisplay : '') + '"></div>' +
			'</ui-select-match>' +
			'<ui-select-choices repeat="item in lists.' + variableName + ' | ' + filter + '">' +
			'<div ng-bind-html="item.' + display + (extraDisplay && extraDisplay.length ? ' + "," + item.' + extraDisplay : '') + (checkForInactive ? ' + (item.state == "inactive" ? " (inactive)" : "")' : '') + '"></div>' +
			'</ui-select-choices>' +
			'</ui-select>' +
			'<div class="inlineEditButtons">' +
			'<button class="button flat" ng-click="cancelInlineEdit(' + taskId + ",'" + variableName + "'" + ')">Cancel</button>' +
			'<button class="button flat colored" ng-disabled="(!inlineEditing.' + variableName + ' && !(inlineEditing.' + variableName + ' === false))" ng-click="saveInlineEdit(' + taskId + ",'" + variableName + "')" + '">Save</button>' +
			'</div>' +
			'</div>';
		return editTemplate;
	}

	function getTagListTemplate(taskId, position, variableName, variableDisplay, display, extraDisplay, myTasksView) {
		var windowWidth = window.innerWidth;
		var windowHeight = window.innerHeight;
		var width = 296;
		var extraClass = '';

		if (myTasksView) {
			windowWidth = jQuery('.task-' + variableName).width();
			windowHeight = jQuery('#procTaskPanel').height() - 49;
		}

		if (position.left + width > windowWidth) {
			position.left = position.left - (position.left + width - windowWidth - 8);
		}
		if (position.top + 112 > windowHeight) {
			position.top = position.top - (position.top + 112 - windowHeight - 8);
		}

		var filter = 'filter: $select.search';

		var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv absolute textEdit ' + extraClass + '" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
			'<div class="inlineEditHeader">Change ' + variableDisplay + '</div>' +
			'<ui-select tagging="tagTransform" theme="bootstrap" ng-model="inlineEditing.' + variableName + '">' +
			'<ui-select-match placeholder="{{' + "'Select " + variableDisplay + "...'" + ' | translate}}">' +
			'<span ng-bind-html="$select.selected.' + display + (extraDisplay && extraDisplay.length ? ' + "," + $select.selected.' + extraDisplay : '') + '"></span>' +
			'</ui-select-match>' +
			'<ui-select-choices repeat="item in lists.' + variableName + ' | ' + filter + '" refresh="$parent.refreshCategoryResults($select)" refresh-delay="0">' +
			'<div ng-if="!item.isTag" ng-bind-html="item.' + display + (extraDisplay && extraDisplay.length ? ' + "," + item.' + extraDisplay : '') + ' + item.extraLabel"></div>' +
			'</ui-select-choices>' +
			'</ui-select>' +
			'<div class="inlineEditButtons">' +
			'<button class="button flat" ng-click="cancelInlineEdit(' + taskId + ",'" + variableName + "'" + ')">Cancel</button>' +
			'<button class="button flat colored" ng-disabled="!inlineEditing.' + variableName + ' && !(inlineEditing.' + variableName + ' === false)" ng-click="saveInlineEdit(' + taskId + ",'" + variableName + "')" + '">Save</button>' +
			'</div>' +
			'</div>';
		return editTemplate;
	}

	$scope.startEditDate = function (taskId, variableName, myTasksView, isSpecificTask) {
		var task = _.find($scope.tasks, {
			id: taskId
		});

		if (!task.active) {
			return;
		}

		if (jQuery('.inlineEditDiv').length) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
		}
		var idField = myTasksView ? '#procTaskPanel' : (isSpecificTask ? '#specificTask' : '#task') + taskId;
		var cell = jQuery(idField + ' .task-' + variableName);
		var pos = cell.position();
		var content = _.find($scope.tasks, {
			id: taskId
		})[variableName];
		var editTemplate = getDateTemplate(taskId, pos, variableName, variableLabel[variableName], myTasksView);
		$scope.inlineEditing[variableName] = content;
		var compiledDiv = $compile(editTemplate)($scope);
		cell.parent().append(compiledDiv);
		compiledDiv.keyup(function (event) {
			var code = event.keyCode || event.which;
			if (code == 13) {
				$scope.saveInlineEdit(taskId, variableName);
			} else if (code == 27) {
				$scope.cancelInlineEdit(taskId, variableName);
			}
		});
		$scope.inlineActive = true;
	};

	$scope.startEditText = function (taskId, variableName, isSpecificTask, characterLimit, myTasksView) {
		var task = _.find($scope.tasks, {
			id: taskId
		});

		if (!task.active) {
			return;
		}

		if (jQuery('.inlineEditDiv').length) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
		}
		var idField = myTasksView ? '#procTaskPanel' : (isSpecificTask ? '#specificTask' : '#task') + taskId;
		var cell = jQuery(idField + ' .task-' + variableName);
		var pos = cell.position();
		var content = _.find($scope.tasks, {
			id: taskId
		})[variableName];
		var editTemplate = getTextTemplate(taskId, pos, variableName, variableLabel[variableName], characterLimit);
		$scope.inlineEditing[variableName] = _.unescape(content);
		var compiledDiv = $compile(editTemplate)($scope);
		cell.parent().append(compiledDiv);
		compiledDiv.keyup(function (event) {
			var code = event.keyCode || event.which;
			if (code == 13 && (typeof characterLimit !== 'undefined' && $scope.inlineEditing[variableName].length <= characterLimit)) {
				$scope.saveInlineEdit(taskId, variableName);
			} else if (code == 27) {
				$scope.cancelInlineEdit(taskId, variableName);
			}
		});
		jQuery('.inlineEditDiv input').focus();
		$scope.inlineActive = true;
	};

	$scope.startEditTextArea = function (taskId, variableName, index, myTasksView, isSpecificTask) {
		var task = _.find($scope.tasks, {
			id: taskId
		});

		if (!task.active) {
			return;
		}

		if (jQuery('.inlineEditDiv').length) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
		}
		var cell;
		var content;
		var idField = myTasksView ? '#procTaskPanel' :  (isSpecificTask ? '#specificTask' : '#task') + taskId;
		if (variableName == 'comments') {
			cell = jQuery(idField + ' .comment-' + index);
			if (task.comments && task.comments[index]) {
				content = task.comments[index].comment;
			} else {
				content = '';
			}

		} else {
			cell = jQuery(idField + ' .task-' + variableName);
			content = _.find($scope.tasks, {
				id: taskId
			})[variableName];
		}
		var containerWidth = cell.parent().outerWidth();
		var pos = cell.position();
		var editTemplate = getTextAreaTemplate(taskId, pos, variableName, variableLabel[variableName], index, myTasksView, containerWidth);
		$scope.inlineEditing[variableName] = _.unescape(content);
		var compiledDiv = $compile(editTemplate)($scope);
		if (variableName == 'comments') {
			cell.parent().append(compiledDiv);
		} else {
			cell.parent().append(compiledDiv);
		}
		compiledDiv.keyup(function (event) {
			var code = event.keyCode || event.which;
			if (code == 13) {
				$scope.saveInlineEdit(taskId, variableName, index);
			} else if (code == 27) {
				$scope.cancelInlineEdit(taskId, variableName);
			}
		});
		jQuery('.inlineEditDiv textarea').focus();
		$scope.inlineActive = true;
	};

	$scope.startEditList = function (taskId, variableName, type, display, extraDisplay, isSpecificTask, myTasksView) {
		var task = _.find($scope.tasks, {
			id: taskId
		});
		if (!task.active) {
			return;
		}

		if (variableName === 'status') {
			if (task.inventoryActionId) {
				urlMap['IAStatus'](factoryNdx).then(function (data) {
					$scope.lists[variableName] = data;
				});
			} else {
				urlMap[variableName](factoryNdx).then(function (data) {
					$scope.lists[variableName] = data;
				});
			}
		} else if (!$scope.lists[variableName]) {
			urlMap[variableName](factoryNdx).then(function (data) {
				$scope.lists[variableName] = data;
			});
		}

		if (jQuery('.inlineEditDiv').length) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
		}
		var idField = myTasksView ? '#procTaskPanel' : (isSpecificTask ? '#specificTask' : '#task') + taskId;
		var cell = jQuery(idField + ' .' + type + '-details ' + '.task-' + variableName);
		var pos = cell.position();
		var content = _.find($scope.tasks, {
			id: taskId
		})[variableName];
		$scope.inlineEditing[variableName] = content;
		var editTemplate = getListTemplate(taskId, pos, variableName, variableLabel[variableName], display, extraDisplay);
		var compiledDiv = $compile(editTemplate)($scope);
		cell.parent().append(compiledDiv);
		compiledDiv.keyup(function (event) {
			var code = event.keyCode || event.which;
			if (code == 13) {
				if (variableName === 'status' && $scope.inlineEditing.status.name === 'Unable to Fix' && !$scope.inlineEditing.reason) {
					event.preventDefault();
					return;
				}
				$scope.saveInlineEdit(taskId, variableName);
			} else if (code == 27) {
				$scope.cancelInlineEdit(taskId, variableName);
			}
		});
		jQuery('.inlineEditDiv input').focus();
		$scope.inlineActive = true;
	};

	$scope.startEditTagList = function (taskId, variableName, display, extraDisplay, myTasksView, isSpecificTask) {
		var task = _.find($scope.tasks, {
			id: taskId
		});

		if (!task.active) {
			return;
		}
		if (!$scope.lists[variableName]) {
			urlMap[variableName](factoryNdx).then(function (data) {
				$scope.lists[variableName] = data;
			});
		}
		if (jQuery('.inlineEditDiv').length) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
		}
		var idField = myTasksView ? '#procTaskPanel' : (isSpecificTask ? '#specificTask' : '#task') + taskId;
		var cell = jQuery(idField + ' .task-' + variableName);
		var pos = cell.position();
		var content = _.find($scope.tasks, {
			id: taskId
		})[variableName];
		var editTemplate = getTagListTemplate(taskId, pos, variableName, variableLabel[variableName], display, extraDisplay, myTasksView);
		$scope.inlineEditing[variableName] = content;
		var compiledDiv = $compile(editTemplate)($scope);
		cell.parent().append(compiledDiv);
		compiledDiv.keyup(function (event) {
			var code = event.keyCode || event.which;
			if (code == 27) {
				$scope.saveInlineEdit(taskId, variableName);
			}
		});
		jQuery('.inlineEditDiv input').focus();
		$scope.inlineActive = true;
	};

	$scope.cancelInlineEdit = function (taskId, variableName) {
		// $scope["hovering" + variableName] = false;
		jQuery('.inlineEditDiv').unbind();
		jQuery('.inlineEditDiv').remove();
		$scope.inlineActive = false;
	};

	$scope.tagTransform = function (newTag) {
		var item = {
			'name': newTag
		};
		return item;
	};

	$scope.refreshCategoryResults = function ($select) {
		var search = $select.search,
			list = angular.copy($select.items),
			FLAG = -1;
		//remove last user input
		list = list.filter(function (item) {
			return item.id !== FLAG;
		});

		if (!search) {
			//use the predefined list
			$select.items = list;
		} else {
			//manually add user input and set selection
			if ($scope.$$childTail.$$childHead && $scope.$$childTail.$$childHead.addActionForm) {
				$scope.$$childTail.$$childHead.addActionForm.category.$setValidity('task-category', search.length < 128);
			}
			if (search.length > 128) {
				$scope.showCategoryMaxLengthError = true;
			} else {
				$scope.showCategoryMaxLengthError = false;
				var userInputItem = {
					id: FLAG,
					name: search,
					extraLabel: ' (Click or press Enter to create)'
				};
				$select.items = [userInputItem].concat(list);
				$select.selected = $select.items[0];
				$select.activeIndex = 0;
				$select.activate($select.items[0]);
			}
		}
	};

	function hasNewCategory(categoryList, category) {
		for (var i = 0; i < categoryList.length; i++) {
			if (categoryList[i].name.toUpperCase() === category.name.toUpperCase()) {
				category.id = categoryList[i].id;
			}

			if (categoryList[i].id === category.id) {
				return false;
			}
		}
		return true;
	}

	function addCategoryInline(category) {
		var cat = {};
		cat.name = strip(category.name);
		return procurementTaskService.addCategory(cat, factoryNdx)
			.then(function (data) {
				category.id = data.val;
				$scope.lists.category.push(category);
			});
	}

	var getStatus = $scope.getStatus = function(statusName) {
		for (var i = 0; i < $scope.actionStatuses.length; i++) {
			if ($scope.actionStatuses[i].name === statusName) {
				return $scope.actionStatuses[i];
			}
		}
	};


	$scope.saveInlineEdit = function (taskId, variableName, index) {
		var targetedTask = _.find($scope.tasks, {
			id: taskId
		});
		var content = $scope.inlineEditing[variableName];
		var isComment = variableName == 'comments';
		var oldVal = isComment ? targetedTask[variableName][index] : targetedTask[variableName];
		if (!isComment) {
			targetedTask[variableName] = content;
			var allowEdit = true;
			var errorMessage = '';
			if (!content && content != false) {
				allowEdit = false;
				errorMessage = 'Please enter a value for ' + variableLabel[variableName];
			}
			if (allowEdit) {
				if (variableName == 'category' && hasNewCategory($scope.lists.category, targetedTask.category)) {
					addCategoryInline(targetedTask.category || [])
						.then(function () {
							var actionObj = targetedTask;
							actionObj.dueDate = formatDate(targetedTask.dueDate);
							if (!actionObj.category.id || actionObj.category.id === -1) {
								// Task category creation was not successful
								$rootScope.$emit('toast', {
									'message': 'Task Category was not created, please try again',
									'success': false
								});
								return;
							}
							editExistingAction(actionObj).then(function () {
								postEditAction(targetedTask);
								$scope.$emit('categoryChanged', {
									'newCategory': targetedTask.category.name
								});
							});
						});
				} else {
					var actionObj = targetedTask;
					editExistingAction(actionObj).then(function () {
						if (variableName == 'responsible') {
							if (!targetedTask.responsible || !targetedTask.responsible.state) {
								targetedTask.responsibleState = 'inactive';
							} else {
								targetedTask.responsibleState = targetedTask.responsible.state;
							}
						}
						if (variableName == 'dueDate') {
							$scope.$emit('dueDateUpdated', {
								'newDueDate': targetedTask.dueDate
							});
						}
						if (variableName === 'category') {
							$scope.$emit('categoryChanged', {
								'newCategory': targetedTask.category.name
							});
						}
						if (variableName === 'subject') {
							$scope.$emit('taskSubjectChanged', {
								'newSubject': targetedTask.subject
							});
						}
						if (variableName === 'description') {
							targetedTask.editTimeFromNow = moment().fromNow();
							targetedTask.descriptionEditorFirstName = globalConfig.user.firstName;
							targetedTask.descriptionEditorLastName = globalConfig.user.lastName;
						}
						postEditAction(targetedTask);
					});
				}
			} else {
				targetedTask[variableName] = oldVal;
				$rootScope.$emit('toast', {
					'message': errorMessage,
					'success': false
				});
			}
		} else {
			$scope.saveComment(taskId, index, content);
		}
		if (variableName === 'status') {
			var obj = {
				'id': targetedTask.inventoryActionId
			};
			targetedTask.status.iconClass = $scope.getStatusIcon($scope.inlineEditing.status.name);
			targetedTask.statusName = $scope.inlineEditing.status.name;
			if ($scope.inlineEditing.status.name === 'Unable to Fix' && $scope.inlineEditing.reasonSectionShown) {
				var reasonComment = 'Unable to Fix: ' + $scope.inlineEditing.reason;
				addCommentToAction({
					'comment': reasonComment,
					'taskId': taskId,
					'isUnableToFixCommentFlag': true
				});
				obj.unableToFixComment = $scope.inlineEditing.reason;
				obj.isUnableToFix = true;
			} else {
				obj.unableToFixComment = undefined;
				obj.isUnableToFix = false;
			}
			$scope.inlineEditing.reason = '';
			$rootScope.$broadcast('updateUnableToFix', obj);
		}
		jQuery('.inlineEditDiv').unbind();
		jQuery('.inlineEditDiv').remove();
		$scope.inlineActive = false;
		// $scope["hovering" + variableName] = false;
	};

	$scope.$on('taskAdded', function(event, data) {
		task = data;
		task.viewMode = 'open';
		task.comments = [];
		taskPrep(task);
		$scope.display.errorMessage = '';
		$scope.tasks.unshift(task);
		$scope.showAddTask = false;
		$scope.specificTaskId = task.id;
		$scope.specificTask = task;
		broadCastShowAddTask();
	});

	//Comment
	function addCommentToAction(comment) {
		var com = {};
		com.comment = comment.comment;
		com.creationUtcTime = new Date().getTime().toString();
		com.actionNdx = comment.taskId;
		com.isUnableToFixCommentFlag = comment.isUnableToFixCommentFlag;
		com.systemGenerated = comment.systemGenerated;
		com.assignToPlannerNdx = comment.assignToPlannerNdx;
		com.unableToFixCategoryNdx = comment.unableToFixCategoryNdx;
		if (comment.comment && comment.comment != '') {
			return procurementTaskService.addComment(com, factoryNdx)
				.then(function (data) {
					if (data && data.status && data.status === 412) {
						$rootScope.$emit('toast', {
							'message': 'This task has already been archived, please refresh your page.',
							'success': false
						});
						return;
					}
					comment.id = data.val;
					comment.creationTime = $filter('date')(parseInt(com.creationUtcTime), 'medium');
					comment.creationTimeFromNow = moment(parseInt(com.creationUtcTime)).fromNow();
					comment.firstName = globalConfig.user.firstName;
					comment.lastName = globalConfig.user.lastName;
					comment.status = 'saved';
					comment.userNdx = globalConfig.user.id;

					var task = _.find($scope.tasks, {
						id: comment.taskId
					});
					if (!_.find(task.watchers, {userNdx:+globalConfig.user.id})) {
						task.watchers.push({userNdx:+globalConfig.user.id});
						watcherSelectInit(task);
					}
					if (!_.find(task.comments, {id: comment.id})) {
						if (comment.systemGenerated) {
							comment.firstName = 'LeanDNA';
							comment.lastName = 'Bot';
							comment.userNdx = 2848;
						}
						task.comments.unshift(comment);
					}
					task.lastModifiedDate = new Date().getTime();
					var updateRowsObject = {};
					updateRowsObject.identifier = {
						taskId: task.id
					};
					updateRowsObject.newValues = {};
					updateRowsObject.newValues.actionLastUpdateDate = moment();
					updateRowsObject.newValues.lastActivityTimestamp = moment().valueOf();
					updateRowsObject.newValues.lastComment = comment.comment;
					updateRowsObject.newValues.lastCommentDate = moment().valueOf();
					updateRowsObject.newValues.lastCommenter = globalConfig.user.firstName + ' ' + globalConfig.user.lastName;
					if (comment.assignToPlannerNdx) {
						updateRowsObject.newValues.isReassign = 1;
					}
					if (com.isUnableToFixCommentFlag) {
						updateRowsObject.newValues.unableToFixComment = comment.comment;
						updateRowsObject.newValues.dateCompleted = new Date();
					}
					$rootScope.$broadcast('updateRows', updateRowsObject);
					if ($scope.row && $scope.rowIndex >= 0 && isSameAction($scope.row, comment)) {
						var commentText = jQuery('#lastComment' + $scope.rowIndex).children();
						commentText.html(strip(comment.comment));
						commentText.attr('title', comment.comment);
						if (com.isUnableToFixCommentFlag) {
							var unableToFixComment = jQuery('#unableToFixComment' + $scope.rowIndex).children();
							unableToFixComment.html(strip(comment.comment));
							unableToFixComment.attr('title', comment.comment);
						}
					}
					$rootScope.$broadcast('updateRows', updateRowsObject);
				});
		}
	}

	function editExistingComment(taskId, index, content) {
		var request = {};
		var task = _.find($scope.tasks, {
			id: taskId
		});

		var comment = task.comments[index];
		request.comment = content;
		request.id = comment.id;
		request.actionNdx = taskId;
		return procurementTaskService.addComment(request, factoryNdx)
			.then(function (data) {
				if (data && data.statusText && data.statusText === 'Precondition Failed') {
					$rootScope.$emit('toast', {
						'message': 'This task has already been archived, please refresh your page.',
						'success': false
					});
					return;
				}
				task.comments[index].comment = content;
				task.lastModifiedDate = new Date().getTime();
				var updateRowsObject = {};
				updateRowsObject.identifier = {
					taskId: task.id
				};
				updateRowsObject.newValues = {};
				updateRowsObject.newValues.actionLastUpdateDate = moment();
				//Set last comment
				updateRowsObject.newValues.lastComment = task.comments[0].comment;
				updateRowsObject.newValues.lastCommentDate = moment().valueOf();
				updateRowsObject.newValues.lastCommenter = globalConfig.user.firstName + ' ' + globalConfig.user.lastName;
				if (task.comments[index].isUnableToFixCommentFlag) {
					updateRowsObject.newValues.unableToFixComment = comment.comment;
				}
				updateRowsObject.newValues = {};
				if ($scope.row && $scope.rowIndex >= 0 && isSameAction($scope.row, task)) {
					if (task.comments[index].isUnableToFixCommentFlag) {
						if (index || index == 0) {
							$scope.row.unableToFixComment = comment.comment;
							var unableToFixComment = jQuery('#unableToFixComment' + $scope.rowIndex).children();
							unableToFixComment.html(strip(comment.comment));
							unableToFixComment.attr('title', comment.comment);
						}
					}
					$rootScope.$broadcast('updateRows', updateRowsObject);
				}
			});
	}

	function clearTaggingVariables(taskId) {
		$scope.watchersObject.prefixForTagging = '';
		$scope.watchersObject.suffixForTagging = '';
		$scope.watchersObject.tempWatchers[taskId] = [];
	}

	function getEmailSuffix() {
		procurementTaskService.getEmailSuffix(factoryNdx).then(function(suffix) {
			$scope.watchersObject.emailSuffix = suffix;
		});
	}

	function watcherSelectInit(task) {
		userListPromise.then(function(userList) {
			if (userList) {
				task.watcherSelectModel = task.watchers.map(function(watcher) {
					return _.find(userList, {ndx: +watcher.userNdx});
				}).filter(function(i) {return i !== undefined;});
			}
		});
	}
	$scope.watcherSelectAdd = function(watcher, model, task) {
		addWatcherToTask(watcher.ndx, task.id);
	};
	$scope.watcherSelectRemove = function(watcher, model, task) {
		return procurementTaskService.removeWatcher(factoryNdx, task.id, watcher.ndx)
			.then(function(response) {
				_.remove(task.watchers, function(w) {
					return w.userNdx == watcher.ndx;
				});
			});
	};

	function addWatchersIfAny(taskId, commentText) {
		var promiseList = [];
		var tempWatchersObj = $scope.watchersObject.tempWatchers[taskId];
		for (var userNdx in tempWatchersObj) {
			var tag = tempWatchersObj[userNdx];
			if (commentText.indexOf(tag) >= 0) {
				var task = _.find($scope.tasks, {
					id: taskId
				});
				if (!_.find(task.watchers, {
					userNdx: +userNdx
				})) {
					promiseList.push(addWatcherToTask(userNdx, taskId, true));
				}
			}
		}
		return promiseList;
	}

	function getWatchersIfAny(taskId, text) {
		var returnList = [];
		var tempWatchersObj = $scope.watchersObject.tempWatchers[taskId];
		for (var userNdx in tempWatchersObj) {
			var tag = tempWatchersObj[userNdx];
			if (text.indexOf(tag) >= 0 && !_.find(returnList, {userNdx: userNdx})) {
				returnList.push({'userNdx': userNdx, 'actionNdx': -1});
			}
		}
		return returnList;
	}

	function addWatcherToTask(userNdx, taskId, quiet){
		return procurementTaskService.addWatcher(factoryNdx, taskId, userNdx, quiet)
			.then(function(response) {
				var task = _.find($scope.tasks, {
					id: taskId
				});
				if (task) {
					task.watchers.push({userNdx: +userNdx});
					watcherSelectInit(task);
				}
			});
	}

	function isSameAction(row, task) {
		return row && ((task.id && task.id === row.taskId)
			|| (task.taskId && task.taskId === row.taskId)
			|| (task.inventoryActionId && task.inventoryActionId === row.actionId));
	}

	function editExistingAction(task) {
		var act = {};
		act.id = task.id;
		act.subject = task.subject;
		act.description = task.description;
		act.categoryNdx = task.category.id;
		act.statusNdx = task.status.id;
		// Grab date prior to further manipulation for logging purposes
		var dateForLogging = task.dueDate;
		// Setting to 6 so that local doesn't go back a day
		var selectedDateUtc = moment(new Date(task.dueDate).setHours(18)).subtract(new Date().getTimezoneOffset(), 'minutes');
		act.dueDate = selectedDateUtc.valueOf();
		act.ownerNdx = task.responsible.ndx;
		act.type = 'PROCUREMENT';
		act.inventoryActionId = task.inventoryActionId;
		selectedDateUtc = moment(new Date(task.reviewLaterExpireDate).setHours(18)).subtract(new Date().getTimezoneOffset(), 'minutes');
		act.reviewLaterExpireDate = selectedDateUtc.valueOf();
		return procurementTaskService.addAction(act, dateForLogging, factoryNdx)
			.then(function (data) {
				if (data.error === 'Conflict') {
					task.status = task.originalStatus;
					task.statusName = task.status.name;
					task.statusNdx = task.status.ndx;
					return task;
				}
				for (var k in data) task[k] = data[k];
				task.completedDate = data.completedDate;
				task.lastModifiedDate = data.lastModifiedDate;
				taskPrep(task);
				
				var updateRowsObject = {};
				updateRowsObject.identifier = {
					taskId: task.id
				};
				updateRowsObject.newValues = {};
				// Updates for procurement tasks page
				updateRowsObject.newValues.actionSubject = strip(task.subject);
				updateRowsObject.newValues.actionCategory = strip(task.category.name);
				updateRowsObject.newValues.actionCategoryNdx = task.category.id;
				updateRowsObject.newValues.responsibleName = strip(task.responsible.firstName + ' ' + task.responsible.lastName);
				updateRowsObject.newValues.iaTaskOwner = updateRowsObject.newValues.responsibleName;
				updateRowsObject.newValues.actionOwner = updateRowsObject.newValues.responsibleName;
				updateRowsObject.newValues.actionOwnerNdx = task.responsible.ndx;
				updateRowsObject.newValues.iaTaskOwnerNdx = updateRowsObject.newValues.actionOwnerNdx;
				updateRowsObject.newValues.responsibleNdx = updateRowsObject.newValues.actionOwnerNdx;
				updateRowsObject.newValues.actionDueDate = parseInt(strip(act.dueDate));
				updateRowsObject.newValues.dueDate = parseInt(strip(act.dueDate));
				updateRowsObject.newValues.lastActivityTimestamp = parseInt(strip(task.lastModifiedDate));
				updateRowsObject.newValues.actionDescription = strip(task.description);
				updateRowsObject.newValues.actionLastUpdateDate = moment();
				updateRowsObject.newValues.status = strip(task.status.name);
				updateRowsObject.newValues.actionStatus = updateRowsObject.newValues.status;
				updateRowsObject.newValues.actionStatusNdx = task.status.id;
				updateRowsObject.newValues.iaStatusNdx = task.status.id;
				updateRowsObject.newValues.actionReviewLaterExpireDate = act.reviewLaterExpireDate ? parseInt(strip(act.reviewLaterExpireDate)) : undefined;
				updateRowsObject.newValues.completedDate = task.completedDate ? $filter('dateYearFirst')(task.completedDate) : '';
				if (task.status.name === 'Open') {
					updateRowsObject.newValues.unableToFixComment = '';
					updateRowsObject.newValues.dateCompleted = undefined;
					updateRowsObject.newValues.unableToFixCategoryName = '';
					updateRowsObject.newValues.actionReviewLaterExpireDate = undefined;
				} else {
					updateRowsObject.newValues.isReassign = 0;
				}
				$rootScope.$broadcast('updateRows', updateRowsObject);

				//only call the service if the tasks updates are coming from my work
				if (($location.url()).indexOf('/my-work') !== -1) {
					notificationService.getUnreadInventoryActions(true);
				}
				
				return data;
			});
	}

	function postEditAction(actionHolder) {
		if ($scope.element) {
			var list = $scope.element.getElementsByClassName('fa-fw');
			var item = list[0];
			if ($scope.incomingLocation === 'shortages report') {
				var iHtml = getInnerHTML(actionHolder.status.name);
				item.innerHTML = iHtml;
			} else {
				item.innerHTML = icons[actionHolder.status.name];
			}
			item.setAttribute('data-qtip', iconTooltip[actionHolder.status.name]);
		} else if ($scope.row && !$scope.rowIndex && $scope.rowIndex != 0 && isSameAction($scope.row, actionHolder)) {
			$scope.row.actionStatus = actionHolder.status.name;
			$scope.row.actionStatusIcon = iconMap[actionHolder.status.name];
			$scope.row.actionStatusTip = iconTooltip[actionHolder.status.name];
		} else if ($scope.row && $scope.rowIndex >= 0 && isSameAction($scope.row, actionHolder)) {
			if (!$scope.row.numTasks || $scope.row.numTasks <= 1) {
				$scope.row.actionStatus = actionHolder.status.name;
				actionHolder.status.iconClass = $scope.getStatusIcon(actionHolder.status.name);
				var statusIcon = jQuery('#actionStatus' + $scope.rowIndex).children().children('i');
				var statusText = jQuery('#actionStatus' + $scope.rowIndex).children().children('span');
				var tooltipHolder = jQuery('#actionStatus' + $scope.rowIndex).children();
				if (statusIcon.hasClass('fa-plus')) {
					statusIcon.removeClass('fa-plus');
					statusIcon.addClass('fa-pencil');
				}
				statusText.html(actionHolder.status.name);
				tooltipHolder.attr('title', iconTooltip[actionHolder.status.name]);
				tooltipHolder.removeClass('grayColor');
			}
		}
		$rootScope.$broadcast('refreshTable');
	}

	$scope.addComment = function () {
		addCommentToAction({
			'comment': $scope.newCommentText,
			'isUnableToFixCommentFlag': false
		});
		$scope.newCommentText = '';
		$scope.showAddComment = false;
	};

	$scope.cancelComment = function () {
		$scope.newCommentText = '';
		$scope.showAddComment = false;
	};

	$scope.saveComment = function (taskId, index, content) {
		if (content && content != '' && index !== -1) {
			editExistingComment(taskId, index, content);
			$scope.editContent = '';
			$scope.editing = false;
			$scope.disableAddComment = false;
		} else if (content && content !== '' && index === -1) {
			addCommentToAction({
				'comment': content,
				'taskId': taskId,
				'isUnableToFixCommentFlag': false
			});
		} else {
			$scope.cancelEdit(index);
		}
	};

	$scope.cancelEdit = function (index) {
		$scope.editContent = '';
		$scope.editing = false;
		$scope.disableAddComment = false;
	};

	$scope.showCommentArea = function () {
		$scope.showAddComment = true;
		$scope.focusCommentArea = true;

		//scroll to the text area
		$location.hash('addCommentTextArea');

		$timeout(function () {
			$anchorScroll();
		});
	};

	$scope.commentsUrl = function () {
		return '/application/f/core/procurement-tasks/modal-task-comments.html';
	};

	$scope.archiveAction = function () {
		$scope.removeAction(true);
	};

	function formatDate(toFormat) {
		var newDate = new Date(toFormat);
		var result = (newDate.getMonth() + 1) + '/' + newDate.getDate() + '/' + newDate.getFullYear();
		return result;
	}

	function getInnerHTML(status) {
		var icon = '&#xf040;';
		var color = '#000';
		if (status == 'None') {
			icon = '&#xf067;';
			color = '#8f8f8f';
		}

		return icon + '<span class="shortages no-click" style="font-family:tahoma, arial, verdana, sans-serif;color:' + color + ';padding-left:12px;">' + status + '</span>';
	}

	$scope.$on('addNewProcurementTask', function (event, incomingInfo) {
		$rootScope.$broadcast('createProcurementTask', incomingInfo);
	});

	$scope.addCommentNew = function (taskId) {
		jQuery('textarea[name="' + taskId + 'comment"] + .show-buttons').removeClass('show-buttons');
		var commentText = jQuery('textarea[name="' + taskId + 'comment"]').val();
		jQuery('textarea[name="' + taskId + 'comment"]').blur();
		if (commentText.replace(/\n/g, '') !== '') {
			var promiseList = addWatchersIfAny(taskId, commentText);
			$q.all(promiseList).then(function() {
				addCommentToAction({
					'comment': commentText,
					'taskId': taskId,
					'isUnableToFixCommentFlag': false
				});
			});
			clearComment(taskId);
		}
	};

	$scope.cancelCommentNew = function (taskId) {
		clearComment(taskId);
		jQuery('textarea[name="' + taskId + 'comment"]').blur();
	};

	function clearComment(taskId) {
		clearTaggingVariables(taskId);
		if (!$scope.specificTask) {
			var task = _.find($scope.tasks, {
				id: taskId
			});
			task.commentText = '';
		} else {
			$scope.specificTask.commentText = '';
		}
		resetCommentAreas();
	}

	$scope.getStatusIcon = function (status, type) {
		return iconMap[status];
	};

	$scope.showMoreDetails = function () {
		$scope.showMoreTaskDetails = !$scope.showMoreTaskDetails;
	};

	$scope.openSpecificTask = function (taskId) {
		$scope.specificTaskId = taskId;
		$scope.specificTask = _.find($scope.tasks, {
			id: taskId
		});
		$scope.specificTask.viewMode = 'open';
		$scope.specificTask.showCommentCount = 1;
	};

	$scope.showAllTasks = function () {
		if ($scope.specificTask) {
			$scope.specificTask.viewMode = 'mini';
		}
		$scope.specificTaskId = '';
		$scope.specificTask = '';
	};

	$scope.showMoreTasks = function () {
		$scope.showTaskCount += 5;
	};

	$scope.archiveTaskDialog = function(task, newTaskInfo) {
		var archiveTaskScope = $scope.$new();
		var opts = {
			scope: archiveTaskScope,
			templateUrl: '/application/f/core/procurement-tasks/archive-task.html',
			backdrop: 'static'
		};

		var instance = $uibModal.open(opts);

		archiveTaskScope.closeDialog = function () {
			instance.close();
			archiveTaskScope.$destroy();
		};
		archiveTaskScope.archiveTask = function () {
			procurementTaskService.deleteAction(task.id, factoryNdx)
			.then(function (data) {
				task.active = false;
				var updateRowsObject = {};
				updateRowsObject.identifier = {
					taskId: task.id
				};
				updateRowsObject.newValues = {};
				updateRowsObject.newValues.actionIsActive = false;
				updateRowsObject.newValues.actionStatusIcon = 'fa fa-plus task-status-none';
				updateRowsObject.newValues.actionStatus = 'Archived';
				updateRowsObject.newValues.actionStatusTip = '';
				$rootScope.$broadcast('updateRows', updateRowsObject);
				instance.close();
				archiveTaskScope.$destroy();
				if (!_.isEmpty(newTaskInfo)) {
					$rootScope.$broadcast('createProcurementTask', newTaskInfo);
				}
			});
		};

	};

	$scope.$on('$destroy', function() {
		document.removeEventListener('click', outsidePopoverClickListener);
	});
}
watcherSelect.$inject = ['$timeout'];
function watcherSelect($timeout) {
	return {
		require: 'uiSelect',
		link: function(scope, element, attrs, $select) {
			scope.$on('focus-watcher-select', function() {
				$timeout(function() {
					$select.activate();
				}, 1);
			});
		}
	};
}
